import React from 'react';

import { joinClasses } from '~/components/utils/react_helper';
import { isImageUrl } from '~/utils/check_image';

const logoClasses = (customClass) => joinClasses(['cobranded-logo', customClass && `cobranded-logo--${customClass}`]);

export default ({ customClass, logo }) => {
  if (isImageUrl(logo)) {
    return (
      <div className={logoClasses(customClass)}>
        <img className="cobranded-logo__agent-image" src={logo} alt="" />
        <div className="cobranded-logo__powered-by-container">
          <span className="cobranded-logo__powered-by">Powered by</span>
          <img
            className="cobranded-logo__residently-logo"
            src="https://s3.eu-west-2.amazonaws.com/resident.ly-production-static-assets/logo/2021/PNG/Residently_Wordmark_logo_Black_RGB.png"
          />
        </div>
      </div>
    );
  }

  return (
    <div className={logoClasses(customClass)}>
      <img
        className="cobranded-logo__agent-image"
        src="https://s3.eu-west-2.amazonaws.com/resident.ly-production-static-assets/logo/2021/PNG/Residently_Wordmark_logo_Black_RGB.png"
        alt=""
      />
    </div>
  );
};
